/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchAddressResultDto } from '../../models/search-address-result-dto';

export interface SearchForProperty$Params {
  road_name: string;
  locality?: string;
  road_number?: string;
  unit_number?: string;
  road_type?: string;
  road_suffix?: string;
}

export function searchForProperty(
  http: HttpClient,
  rootUrl: string,
  params: SearchForProperty$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchAddressResultDto>> {
  const rb = new RequestBuilder(rootUrl, searchForProperty.PATH, 'get');
  if (params) {
    rb.query('road_name', params.road_name, {});
    rb.query('locality', params.locality, {});
    rb.query('road_number', params.road_number, {});
    rb.query('unit_number', params.unit_number, {});
    rb.query('road_type', params.road_type, {});
    rb.query('road_suffix', params.road_suffix, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchAddressResultDto>;
      }),
    );
}

searchForProperty.PATH = '/search/address/property';
